import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useAuth } from '../context/AuthContext';
import { useFavoritos } from '../context/FavoritosContext';
import './FavoritoButton.css';

// Corazón reusable: en PosterGrid.jsx (catálogo y /favoritos) y en
// Customize.jsx (detalle de producto). Sin sesión, manda a /login en vez
// de intentar favoritar (favoritos requiere cuenta).
const FavoritoButton = ({ productoId }) => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { isFavorito, toggleFavorito } = useFavoritos();

  const active = isLoggedIn && isFavorito(productoId);

  const handleClick = () => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }
    toggleFavorito(productoId);
  };

  return (
    <button
      type="button"
      className={`favorito-button${active ? ' is-active' : ''}`}
      onClick={handleClick}
      aria-label={active ? 'Quitar de favoritos' : 'Agregar a favoritos'}
    >
      {active ? 'Quitar de Favoritos' : 'Agregar a Favoritos'}
      {active ? <FavoriteIcon /> : <FavoriteBorderIcon />}
    </button>
  );
};

FavoritoButton.propTypes = {
  productoId: PropTypes.number.isRequired,
};

export default FavoritoButton;
